/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Prescription_PeriodInputs */

const en_case_prescription_period = /** @type {(inputs: Case_Prescription_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prescription period`)
};

const pt_br2_case_prescription_period = /** @type {(inputs: Case_Prescription_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de prescrição`)
};

/**
* | output |
* | --- |
* | "Prescription period" |
*
* @param {Case_Prescription_PeriodInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_prescription_period = /** @type {((inputs?: Case_Prescription_PeriodInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Prescription_PeriodInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_prescription_period(inputs)
	return pt_br2_case_prescription_period(inputs)
});